import type { MRT_RowData, MRT_TableOptions } from 'material-react-table';

export const defaultTableStyles = {
  muiTableProps: {
    sx: {
      '& .MuiTableCell-root': {
        borderBottom: '1px solid',
        borderColor: 'divider',
      },
    },
  },
  muiTableHeadCellProps: {
    sx: {
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '0.875rem',
      p: '0px 10px !important',
      color: '#212B36',
      borderRadius: 0,
    },
  },
  muiTableHeadProps: {
    sx: {
      '& .MuiTableCell-head': {
        alignContent: 'center',
      },
    },
  },
  muiTableHeadRowProps: {
    sx: {
      height: '56px',
      backgroundColor: '#F5F6F8',
      '& .MuiTableCell-root': {
        textAlign: 'center',
        fontSize: '0.875rem',
      },
    },
  },
  muiTableBodyRowProps: {
    sx: {
      backgroundColor: 'transparent',
      '&:hover': { backgroundColor: '#F5F6F8' },
      '&:hover td::after': { content: 'none' },
    },
  },
  muiTableBodyCellProps: {
    sx: {
      p: '8px 10px',
      fontSize: '0.875rem',
      height: 'auto',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
  },
  muiTablePaperProps: {
    sx: {
      borderWidth: 0,
      boxShadow: 'none',
      backgroundImage: 'none',
      backgroundColor: 'transparent',
    },
  },
} satisfies Partial<MRT_TableOptions<MRT_RowData>>;

export const defaultPaginationStyles = {
  muiPaginationProps: {
    rowsPerPageOptions: [25],
    showRowsPerPage: false,
    shape: 'rounded',
    variant: 'outlined',
  },
  muiBottomToolbarProps: {
    sx: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
} satisfies Partial<MRT_TableOptions<MRT_RowData>>;
